class BarracudaSlideshow{
    constructor(element, time = 500){
        this.debug = false;
        if(element){
            this.slideshow = element;
            this.fade = this.slideshow.classList.contains("animation-fade") ? true : false;
            /* add gestures */
            if(typeof Swipe !== 'undefined')
                new Swipe(this.slideshow);

            this.data = element.dataset;
            this.classList = element.classList;
            this.time = time;

            this.init();
        }else
            console.error("BarracudaSlideshow: Construct must contains element!");
    }
    init(){

        /* if we work with testimonials, we need set element height */
        if(this.slideshow.classList.contains("testimonials")){
            setTimeout(()=>{
                this.setTestimonialsHeight();
                window.addEventListener("resize", this.setTestimonialsHeight.bind(this));
            },10)
           
        }

        /* create controls */
        this.controls();

        /* initializated start position */
        this.current = {
            "int": this.data.start? parseInt(this.data.start) : 1,
            "element": this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child("+(this.data.start? this.data.start : 1)+")")
        }
        if(this.current.element){ /* test for empty slideshow */
            this.current.element.classList.add("current");
            this.defineColors(this.current.element);
            this.refreshControls(this.current.int);
        }

        /* initializade slideshow length */
        this.length = parseInt(this.slideshow.querySelectorAll(".barracuda-slideshow-slide").length);

        /* set lock */
        this.lock = false;

        /* set autoplay */
        this.autoplay = this.data.autoplay? this.data.autoplay : false;
        this.timeout = null;
        if(this.autoplay)
            this.start();

        /* animate background */
       //this.animate()

        /* add swipe listeners */
        this.slideshow.addEventListener("swipe", this.swipe.bind(this));

        this.classList.add("barracuda-slideshow-initialized");
    }

    animate(){
        this.zoomAnimate = anime({
            targets: this.current.element.querySelector(".slide-content.slide-background>img"),
            scale: [1 , 1.2],
            duration: 10000,
            easing: "easeOutQuad"
        })
    }
    setTestimonialsHeight(){
        var x = 0;
        this.slideshow.querySelectorAll(".slide-content .text-frame>div").forEach(el=>{
            if(el.scrollHeight > x) x = el.scrollHeight; 
        });
        x + this.slideshow.querySelector(".barracuda-slideshow-controls").scrollHeight;
        if(this.controls.hidden){
            /* without dots (controls) */
            this.slideshow.style.height = "calc("+ x + "px)";
        }else{
            /* with dots (controls) */
            this.slideshow.style.height = "calc(48px + "+ x + "px)";
        }
    }

    swipe(e){
        if (e.detail && e.detail.direction) {
            if (this.vertical) {
                switch (e.detail.direction) {
                    case "down":
                        if (this.current.int < this.length)
                            this.next()
                        break;
                    case "up":
                        if (this.current.int > 0)
                            this.prev();
                        break;
                }
            }else{
                switch (e.detail.direction) {
                    case "left":
                        this.next();
                        break;
                    case "right":
                        this.prev();
                        break;
                    default:
                        break;
                }
            }
        }
    }
    prev(useAnimation = true){
        var temp = this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child("+(this.current.int - 1)+")")
        if(temp)
            var prev = {
                "int": this.current.int - 1,
                "element": temp
            }
        else
            var prev = {
                "int": this.length,
                "element": this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child("+(this.length)+")")
            }

        this.setPosition(prev, useAnimation);
    }

    next(useAnimation = true){        
        var temp = this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child("+(this.current.int + 1)+")")
        if(temp)
            var next = {
                "int": this.current.int + 1,
                "element": temp
            }
        else
            var next = {
                "int": 1,
                "element": this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child(1)")
            }

        this.setPosition(next, useAnimation);
    }

    set(index, useAnimation = true){
        index = parseInt(index);
        var temp = this.slideshow.querySelector(".barracuda-slideshow-slide:nth-child("+index+")")
        if(temp){
            if(this.autoplay){
                this.stopAutoplay();
            }
            this.autoplay = false;
            this.setPosition({
                "int": index,
                "element": temp
            }, useAnimation);
        }else
            console.error("BarracudaGallery: Slide with index "+ index + "doesn't exists");
    }

    setPosition(to, useAnimation = true){
        if(!this.lock){
            if(this.current.int != to.int){
                this.lock = true;
                this.stop();

                this.refreshControls(to.int);

                if (this.current.element.querySelector(".aos-init")) {
                    let currentText = this.current.element.querySelector(".aos-init")
                    setTimeout(() => {
                        currentText.classList.remove("aos-init", "aos-animate")
                        currentText.removeAttribute("data-aos")
                    },1000)
                    
                    if (to.element.querySelector(".text-content")) {
                        let futureText = to.element.querySelector(".text-content")
                        futureText.style.opacity = 0;
                        setTimeout(() => {
                            futureText.setAttribute("data-aos","fade-up")
                        },6)
                    }
                }
                var after = function () {
                    this.current.element.classList.remove("current");
                    if (this.current.element.querySelector(".slide-content.slide-background>img")) {
                        this.current.element.querySelector(".slide-content.slide-background>img").style.removeProperty("transform");
                    }
                    if (to.element.querySelector(".text-content[data-aos=fade-up]")){
                        let futureText = to.element.querySelector(".text-content")
                        futureText.style.removeProperty("opacity")
                        futureText.classList.add("aos-init","aos-animate")
                    }
                    this.current.element.style.zIndex = 1;
                    to.element.classList.add("current");

                    this.current = to;

                    if(this.autoplay)
                        this.start();

                    this.lock = false;
                }.bind(this);
                
                this.defineColors(to.element);
                if(useAnimation){
                    anime.timeline({
                        duration: this.time,
                        easing: "linear",
                    }).add({
                        targets: this.current.element,
                        duration: 0,
                        zIndex: 2
                    }).add({
                        targets: to.element,
                        duration: 0,
                        zIndex: 3
                    }).add(this.fade ? {
                        targets: this.current.element,
                        opacity: [1, 0],
                    }:{},3).add(this.fade ? {
                        targets: to.element,
                        opacity: [0, 1],
                        complete: after
                    } : {
                        targets: to.element,
                        translateX: ["100vw", "0"],
                        complete: after
                    }, 0)
                } else {
                    if (this.fade) {
                        this.current.element.style.zIndex = 2
                        this.current.element.style.opacity = 0
                        to.element.style.zIndex = 3
                        to.element.style.opacity = 1
                        after()
                    } else {
                        this.current.element.style.zIndex = 2
                        to.element.style.zIndex = 3
                        to.element.style.translateX = 0;
                        after()
                    }
                }
            }
        }else
            console.warn("BarracudaGallery: Too fast, slideshow is locked.",to.int);
    }

    start(){
        this.autoplay = this.data.autoplay? this.data.autoplay : false;

        this.slideshow.classList.add("slideshow-playing");
        this.slideshow.classList.remove("slideshow-stopped");
        
        this.timeout = setTimeout(this.next.bind(this), this.autoplay);
    }
    stop(){
        clearTimeout(this.timeout);
    }
    stopAutoplay(){
        if(this.slideshow.classList.contains("slideshow-playing")){
            this.slideshow.classList.add("slideshow-stopped");
            this.slideshow.classList.remove("slideshow-playing");
        }
        this.stop();
    }

    defineColors(targetElement){
        if(!this.data.disablecolors){
            if(targetElement.classList.contains("inverted")){
                this.slideshow.parentElement.classList.add("use-inverted-colors")
                this.slideshow.classList.add("use-inverted-colors")
            if(this.slideshow.offsetTop == 0)
                document.body.classList.add("use-inverted-colors")
            }else{
                this.slideshow.parentElement.classList.remove("use-inverted-colors")
                this.slideshow.classList.remove("use-inverted-colors")
                if(this.slideshow.offsetTop == 0)
                    document.body.classList.remove("use-inverted-colors")
            }
            if(Barracuda.elements.Overlapping)
                Barracuda.elements.Overlapping.check();
        }
    }
    controls(){
        /* main container */
        this.controls = {
            "element": this.slideshow.querySelector(".barracuda-slideshow-controls"),
            "dots": this.slideshow.querySelector(".barracuda-slideshow-controls-dots"),
            "dotTemplate": this.slideshow.querySelector(".barracuda-slideshow-controls-dot"),
            "playIcon": this.slideshow.querySelector(".barracuda-slideshow-controls-play"),
            "pauseIcon": this.slideshow.querySelector(".barracuda-slideshow-controls-pause"),
            "hidden" : false
        };

        this.controls.dots.innerHTML = "";
        if(this.controls.playIcon && this.controls.pauseIcon){
            this.controls.dots.appendChild(this.controls.playIcon);
            this.controls.playIcon.addEventListener("click",this.start.bind(this));

            this.controls.dots.appendChild(this.controls.pauseIcon);
            this.controls.pauseIcon.addEventListener("click",this.stopAutoplay.bind(this));}

        this.slideshow.querySelectorAll(".barracuda-slideshow-slide").forEach((element, index) => {
            var temp = this.controls.dotTemplate.cloneNode();
            temp.addEventListener("click",(()=>{
                    this.set((index + 1));
                    this.stop();
                }).bind(this));
            this.controls.dots.appendChild(temp);
        });

        if(this.slideshow.querySelectorAll(".barracuda-slideshow-slide").length <= 1){
            this.controls.dots.classList.add("hide");
            if(this.controls.element && this.controls.element.childElementCount <= 1 && this.controls.element.querySelector(".barracuda-slideshow-controls-dots")){
                this.controls.element.classList.add("hide");
                this.controls.hidden = true;
            }
        }
    }
    refreshControls(position = 1){
        if(this.slideshow.querySelector(".barracuda-slideshow-controls-dot.active"))
            this.slideshow.querySelector(".barracuda-slideshow-controls-dot.active").classList.remove("active");
        if(this.data.autoplay){     
            if(this.slideshow.querySelector(".barracuda-slideshow-controls-dot:nth-of-type("+(2 + position)+")"))
                this.slideshow.querySelector(".barracuda-slideshow-controls-dot:nth-of-type("+(2 + position)+")").classList.add("active");
        }else{
            if(this.slideshow.querySelector(".barracuda-slideshow-controls-dot:nth-of-type("+position+")"))
                this.slideshow.querySelector(".barracuda-slideshow-controls-dot:nth-of-type("+position+")").classList.add("active");
        }
        
        function dotsVisibility(dots, from = null, to = null){
            if(dots.length>0){
                dots.forEach(dot=>{
                    dot.classList.remove("end");
                    dot.classList.add("visible");
                })
                if(from){
                    for (let i = 0; i < from; i++) {      
                        if(dots[i]) dots[i].classList.remove("visible");
                    }
                    if(dots[from]) dots[from].classList.add("end");
                }
                if(to){
                    for (let i = to; i < dots.length; i++) {
                        if(dots[i]) dots[i].classList.remove("visible");
                    }
                    if(dots[(to-1)] && (to != dots.length)) dots[(to-1)].classList.add("end");
                }
            }
        }
        var dots = this.slideshow.querySelectorAll(".barracuda-slideshow-controls-dot")
        var visibleDots = 5; // count of visible dots
        var dotsCount = dots.length;
        // postion - active dot
        // dots - all dots
        if(this.length <= visibleDots)
            dotsVisibility(dots);
        else if(position < 3)
            dotsVisibility(dots,null,visibleDots);
        else if((position + 2)> this.length)
            dotsVisibility(dots,(dotsCount-visibleDots),null);
        else
            dotsVisibility(dots,(position - 3),(position + 2))
    }
}

/* ********************************** */
/* ***** Barracuda Slideshow v4 ***** */
/* ********************************** */
customElements.define('barracuda-slideshow-timeline', class BarracudaSlideshowTimeline extends HTMLElement{
    constructor(){
        super()
        this.slideshow = this.closest("barracuda-slideshow-core")
        this.timeSlider = document.createElement("span")
        this.timeSlider.classList.add("time-slider")
        this.appendChild(this.timeSlider)

        if (this.slideshow) {
            if (this.getAttribute('width-as')){
                this.widthElement = this.slideshow.querySelector("#" + this.getAttribute('width-as'));
                if (this.widthElement) {
                    setTimeout(this.setSize.bind(this), 100)
                    this.widthElement.addEventListener("DOMchange", this.setSize.bind(this))
                }
            }

            if(this.slideshow.getAttribute("autoplay"))
                this.stateChange("playing")
            
            if (this.slideshow.getAttribute("time-on-slide"))
                this.setTime(this.slideshow.getAttribute("time-on-slide"))
            
            this.slideshow.addEventListener("slideshow:state:change", ((event)=>{
                let state = event.detail.state
                if(state) this.stateChange(state)
            }).bind(this))
        }
    }
    setTime(time) {
        this.timeSlider.style.setProperty("--duration", ( parseInt(time) * 1000 - 20) + 'ms')
    }
    setSize() {
        this.style.width = this.widthElement.scrollWidth + "px";
    }
    stateChange(state) {
        if (state == "playing") {
            this.renewState();
            /* this.style.opacity = 1 */
        } else if (state == "paused") {
            this.timeSlider.classList.remove("running")
            /* this.style.opacity = 0; */
        }
    }
    renewState() {
        this.timeSlider.classList.remove("running")
        setTimeout((() => { this.timeSlider.classList.add("running") }).bind(this), 10);
    }
})
customElements.define('barracuda-slideshow-button', class BarracudaSlideshowButton extends HTMLElement{
    constructor(){
        super()
        this.slideshow = this.closest("barracuda-slideshow-core")
        if(this.slideshow){
            this.addEventListener("click", ()=>{
                let action = this.getAttribute("action")
                if(action)
                this.slideshow.dispatchEvent(new CustomEvent('slideshow:action',{detail:{"action": action }}))
            })
        }
    }
})
customElements.define('barracuda-slideshow-state', class BarracudaSlideshowState extends HTMLElement{
    constructor(){
        super()
        this.slideshow = this.closest("barracuda-slideshow-core")
        this.state = this.slideshow.getAttribute("autoplay")
        if(this.state) this.stateChange("playing")
        else this.stateChange("paused")

        this.slideshow.addEventListener("slideshow:state:change", ((event)=>{
            let state = event.detail.state
            if(state) this.stateChange(state)
        }).bind(this))
    }
    stateChange(state){
        this.querySelectorAll(".state:not(." + state + ")").forEach(element => {
            element.classList.add("hidden")
        })
        this.querySelectorAll(".state."+state).forEach(element => {
            element.classList.remove("hidden")
        })
    }
})

customElements.define('barracuda-slideshow-dots', class BarracudaSlideshowDots extends HTMLElement {
    constructor() {
        super()
        // Init array
        this.dots = []

        // Get dots style
        this.dotStyle = this.getAttribute("dot-style")? this.getAttribute("dot-style") : "default"

        // Generate all dots
        this.generate()

        // Set current dot
        this.set(parseInt(this.getAttribute("current")? this.getAttribute("current") : 0))

        // Add listeners for Slideshow
        this.closest('barracuda-slideshow-core').addEventListener("slideshow:slide:unloaded",((event)=>{
            if(event.detail.sectionId == this.getAttribute('section-id'))
            this.set(event.detail.to.index)
        }).bind(this))
    }
    generate(){
        // Clean inside
        this.innerHTML = ""
        // Get dots count
        let count = parseInt(this.getAttribute("count")?this.getAttribute("count"):0)
        // If we have count...
        if(count>0){
            for (let index = 0; index < count; index++) {
                // Create element
                let dot = document.createElement("span")
                // Add classes
                dot.classList.add("barracuda-slideshow-dot")
                // Add dot-style
                dot.classList.add("dot-style-" + this.dotStyle)
                // Add click listener
                dot.addEventListener("click",(()=>{
                    // pause slideshow
                    this.closest("barracuda-slideshow-core").dispatchEvent(new CustomEvent('slideshow:action',{detail:{"action": "pause" }}))
                    // set nth slide
                    this.closest("barracuda-slideshow-core").dispatchEvent(new CustomEvent('slideshow:action',{detail:{"action": "set", "nth": index }}))
                }).bind(this))
                // Append to element
                this.appendChild(dot)
                // append to global array
                this.dots[index] = dot
            }
        }
    }
    set(nth){
        if(!(this.current == nth)){
            // remove class from current dot (only if we know current dot)
            if(this.current != undefined) this.dots[this.current].classList.remove("active")
            // asign new current
            this.current = nth
            // Add class to current dot
            this.dots[this.current].classList.add("active")

            // Change dots visibility
            let visibleDots = parseInt(this.getAttribute("visible-dots")? this.getAttribute("visible-dots"): 0)
            let visibleDotsMargin = (visibleDots>1)? parseInt((visibleDots - 1) /2):0
            if(visibleDots > 0){
                function dotsVisibility(dots, from = null, to = null){
                    if(dots.length>0){
                        dots.forEach(dot=>{
                            dot.classList.remove("end");
                            dot.classList.add("visible");
                        })
                        if(from){
                            for (let i = 0; i < from; i++) {      
                                if(dots[i]) dots[i].classList.remove("visible");
                            }
                            if(dots[from]) dots[from].classList.add("end");
                        }
                        if(to){
                            for (let i = to; i < dots.length; i++) {
                                if(dots[i]) dots[i].classList.remove("visible");
                            }
                            if(dots[(to-1)] && (to != dots.length)) dots[(to-1)].classList.add("end");
                        }
                    }
                }
                var dotsCount = this.dots.length;
                if(this.dots.length <= visibleDots)
                    dotsVisibility(this.dots);
                else if(this.current <= visibleDotsMargin)
                    dotsVisibility(this.dots,null,visibleDots);
                else if((this.current + visibleDotsMargin) >= dotsCount){
                    dotsVisibility(this.dots,(dotsCount - visibleDots),null);
                }else
                    dotsVisibility(this.dots,(this.current - visibleDotsMargin),(this.current + 1 + visibleDotsMargin))
            }
        }
    }
})
customElements.define('barracuda-slideshow-core', class BarracudaSlideshowCore extends HTMLElement {
    constructor() {
        super()
        // init section
        this.init()

        // add event listeners
        this.addEventListener("slideshow:action", event=>{
            switch (event.detail.action) {
                case "set":
                    this.set(event.detail.nth)
                    break;
                default:
                    this[event.detail.action]()
                    break;
            }
        })

        document.addEventListener("shopify:block:select", (event => {
            if(event.detail.sectionId == this.getAttribute('section-id')){
                let block = this.querySelector("#shopify-block-" + event.detail.blockId)
                if(block){
                    this.set(parseInt(block.dataset.nth), 0)
                }
                this.pause()
                this.setHeight()
            }
        }).bind(this));
        document.addEventListener("shopify:block:deselect", (event => {
            if(event.detail.sectionId == this.getAttribute('section-id')){
                this.play()
                this.setHeight()
            }
        }).bind(this));
        document.addEventListener("shopify:section:load", (event => {
            if(event.detail.sectionId == this.getAttribute('section-id')){
                this.init()
            }
        }).bind(this));
    }
    init(){
        // Select all slides in slideshow
        this.slides = this.querySelectorAll(".slide")
        // Find first slide (defined with current or first child)
        let firstSlide = this.querySelector(".slide.current")? this.querySelector(".slide.current") : (this.querySelector(".slide")? this.querySelector(".slide") : false)
        // If we have slides and one as current, we can continue in working
        if(this.slides){
            // Define current slide
            this.current = {
                "index" : parseInt(firstSlide.dataset.nth),
                "element" :  firstSlide
            }
            // Check slideshow height
            this.setHeight()
            window.addEventListener("resize",this.setHeight.bind(this))

            // if slide doesn't have the current class, add it
            this.current.element.classList.add("current")

            // Get current slide color and adapt slideshow to it
            this.setColors(this.current.element);

            // Check autoplay attribute and start playing
            if(this.getAttribute("autoplay")) this.play()

        }else{
            // Oterwise send error
            console.log("BarracudaSlideshowCore: 1 slide is minimum")
        }
    }
    next(){
        // check if next exist otherwise set first
        this.set((this.slides.length > this.current.index + 1)? this.current.index + 1 : 0)
    }
    before(){
        this.set((0 <= this.current.index - 1)? this.current.index - 1 : this.slides.length)
    }
    setColors(element) {
        let color = getComputedStyle(element).getPropertyValue('--text_color')
        this.style.setProperty('--text_color', color)
        let backgroundColor = getComputedStyle(element).getPropertyValue('--background_color')
        this.style.setProperty('--background_color', backgroundColor)

        // check if header overlay and if is a transparent
        let transparentHeader = document.querySelector("#header.can-be-transparent")
        if (transparentHeader && (this.closest('.shopify-section').classList.contains("first-of-content") || BarracudaStore.functions.isOverlapping(transparentHeader, this.closest('.shopify-section')) )) {
            if (element.getAttribute("inverted")){
                transparentHeader.classList.add("use-inverted-colors")
                this.closest('.shopify-section').classList.add("use-inverted-colors")
            }else {
                transparentHeader.classList.remove("use-inverted-colors")
                this.closest('.shopify-section').classList.remove("use-inverted-colors")
            }
        }
    }
    setHeight() {
        this.style.setProperty("--largest-height", "var(--height)")
        // init minimum
        let largestHeight = 0
        // check all slides
        this.slides.forEach(slide => {
            if (slide.scrollHeight > largestHeight) largestHeight = slide.scrollHeight
        })
        // set size as height
        this.style.setProperty("--largest-height", largestHeight + "px")
    }
    set(nth,withAnimation = true){
        // Check if slideshow isn't locked
        if(!this.lock){
            // Lock slideshow
            this.lock = true

            // Predefine next slide
            let to = { "index": nth, "element": this.slides[nth] }
            // Predefine current
            let from = this.current

            // Animate slides
            let animationDuration = withAnimation? 600 : 10
            this.style.setProperty('--animation-duration', animationDuration + 'ms');
            // Get target slide color and adapt slideshow to it
            this.setColors(to.element)

            // Animate text AOS
            if(from.element.querySelector(".aos-init")) {
                let currentText = from.element.querySelector(".aos-init")
                setTimeout(() => {
                    currentText.classList.remove("aos-init", "aos-animate")
                    currentText.removeAttribute("data-aos")
                },1000)
                
                if (to.element.querySelector(".text-content")) {
                    let futureText = to.element.querySelector(".text-content")
                    futureText.style.opacity = 0;
                    setTimeout(() => {
                        futureText.setAttribute("data-aos","fade-up")
                    },6)
                }
            }
        
            setTimeout(()=>{
                from.element.classList.add("leaving")
                to.element.classList.add("upcoming")
                // Dispatch event announcement
                this.dispatchEvent(new CustomEvent("slideshow:slide:unloaded",{ detail: {
                    "sectionId": this.getAttribute("section-id"),
                    "slide": from, "from": from, "to": to, "duration": animationDuration 
                }}))
                setTimeout(()=>{
                    from.element.classList.remove("current")
                    to.element.classList.add("current")
                    setTimeout(()=>{
                        from.element.classList.remove("leaving")
                        to.element.classList.remove("upcoming")
                        // Save target as current 
                        this.current = to

                        // Animate AOS
                        if (to.element.querySelector(".text-content[data-aos=fade-up]")){
                            let futureText = to.element.querySelector(".text-content")
                            futureText.style.removeProperty("opacity")
                            futureText.classList.add("aos-init","aos-animate")
                        }

                        //Dispatch event announcement
                        document.dispatchEvent(new CustomEvent("slideshow:slide:loaded",{ detail: {
                            "sectionId": this.getAttribute("section-id"),
                            "slide": to, "from": from, "to": to, "duration": animationDuration 
                        }}))

                        // Unlock slideshow
                        this.lock = false
                        if(this.state == "playing") this.play()
                    },10)
                },animationDuration)
            },10)

        }
    }
    pause(){
        //If we have timeout then clear it
        if(this.timeout) clearTimeout(this.timeout)
        this.state = "paused"
        // dispatch state
        this.dispatchEvent(new CustomEvent("slideshow:state:change", {detail: {"state": "paused"}}))
    }
    play(){
        //If we have timeout then clear it
        if(this.timeout) clearTimeout(this.timeout)

        // Get time on slide or use default value (2s)
        let timeOnSlide = parseInt(this.getAttribute('time-on-slide')? this.getAttribute('time-on-slide'): 2) * 1000
        // Start timer
        this.timeout = setTimeout(this.next.bind(this),timeOnSlide)
        this.state = "playing"
        // dispatch state
        this.dispatchEvent(new CustomEvent("slideshow:state:change", {detail: {"state": "playing"}}))
    }
});